import { render, staticRenderFns } from "./Activations.vue?vue&type=template&id=bb2bdf8e&scoped=true"
import script from "./Activations.vue?vue&type=script&lang=ts"
export * from "./Activations.vue?vue&type=script&lang=ts"
import style0 from "./Activations.vue?vue&type=style&index=0&id=bb2bdf8e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2bdf8e",
  null
  
)

export default component.exports